import React, { useState } from 'react';

import { useForm, zodResolver } from '@mantine/form';
import { t } from 'i18next';
import * as z from 'zod';
import { observer } from 'mobx-react';
import { AppMedError } from '../../../global/error/AppMedError.ts';

import { useNavigate } from 'react-router-dom';
import { Paper } from '@mantine/core';
import Questionnaire from '../../Survey/AppmedSurvey.tsx';
import { IQuestionnaireAnswerPayload } from '../../../global/entities/QuestionnaireAnswer/QuestionnaireAnswer.ts';
import { usePostQuestionnaireAnswer } from '../../../global/entities/QuestionnaireAnswer/mutations/usePostQuestionnaireAnswerMutations.tsx';
import { useGetTaskSummaries } from '../../../global/entities/Tasks/queries/useGetTaskSummaries.tsx';
import { useParams } from 'react-router';

const QuestionnaireForm: React.FC = observer(() => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const { id: taskId } = useParams<{ id: string }>();
    const { refetch: refetchTaskSummaries } = useGetTaskSummaries();

    const postQuestionnaireAnswer = usePostQuestionnaireAnswer();

    const schema = z.object({
        firstName: z.string().min(1, { message: t('formError.invalidUserName') }),
        lastName: z.string().min(1, { message: t('formError.invalidUserName') }),
        email: z.string().min(1, { message: t('formError.invalidEmailAddress') }),
    });

    const form = useForm({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            role: '',
        },
        validate: zodResolver(schema),
    });

    const handleCancel = () => {
        form.reset();
        navigate('/patientDashboard/mainPatient');
    };

    const handleSubmit = async (formValues: IQuestionnaireAnswerPayload) => {
        setError(null);

        try {
            await postQuestionnaireAnswer.mutateAsync(formValues);
            console.log(t('submissionSuccess'));
        } catch (e) {
            if (e instanceof AppMedError) 
                setError(e.message);
             else {
                setError('An unexpected error occurred.');
                console.error(error);
            }
        } finally {
            refetchTaskSummaries();
            
            setTimeout(() => handleCancel(), 4000);
        }
    };

    return (
        <Paper h={'100%'} w={'100%'} mb={'xl'}>
            <Questionnaire
                taskId={taskId}
                handleSubmit={handleSubmit}
            />
        </Paper>
    );
});

export default QuestionnaireForm;
